<app-filter-dialog #filtrarMes (onSeleccionar)="filtrarMesOnSeleccionar($event)"/>
<app-filter-dialog #filtrarEstadoTramite (onSeleccionar)="filtrarEstadoTramiteOnSeleccionar($event)"/>
<app-filter-dialog #filtrarMesDetalle (onSeleccionar)="filtrarMesDetalleOnSeleccionar($event)"/>
<app-filter-dialog #filtrarFuncionarioDetalle (onSeleccionar)="filtrarFuncionarioDetalleOnSeleccionar($event)"/>

<main class="dash-page">
  <div class="dash-topbar h-fit">
    <div class="col-12">
      <div class="dash-header">
        <div class="flex justify-content-between align-items-center">
          <CustomTitle [title]="(translations.titulo1 || 'Trámites') + ' - Sisbén'" [showTag]="false" styleClass="dash-title"/>
        </div>
      </div>
      <div class="flex gap-1 mt-1">
        <button pButton type="button" class="p-button-outlined" [label]="filtrarMesText"
                (click)="openFiltrarMesDialog()"></button>
        <button pButton type="button" class="p-button-outlined" [label]="filtrarEstadoTramiteText"
                (click)="openfiltrarEstadoTramiteDialog()"></button>
      </div>
    </div>
  </div>

  <div class="dash-content">
    <div class="grid">
      <div class="col-12">
        <div class="dash-card">
          <div class="dash-body">
            <app-dashboard-table-selectable
              [config]="configTable"
              [loading]="isLoadingTramitePorDependencia"
              [selectionMode]="'single'"
              [(selection)]="selectedTramitePorDependencia"
              (selectionChange)="tramitePorDependenciaSelectionChange($event)"/>
          </div>
        </div>
      </div>
      @if (isDetailVisible) {
        <div class="col-12 mt-2">
          <div class="flex gap-3 flex-wrap align-items-center">
            <CustomTitle [title]="translations.titulo2" styleClass="dash-title" [showTag]="false"/>
            <div class="flex-1"></div>
            <button pButton type="button" class="p-button-outlined"
                    [label]="filtrarMesDetalleText"
                    (click)="openFiltrarMesDetalleDialog()"></button>
            <button pButton type="button" class="p-button-outlined"
                    [label]="filtrarFuncionarioDetalleText"
                    (click)="openfiltrarFuncionarioDetalleDialog()"></button>
          </div>
        </div>
        @for (item of tramiteDetails | keyvalue; track item.key) {
          @if (item.value) {
            <div class="grid col-12">
              <div class="col-12 md:col-4 lg:col-3">
                <div class="dash-card">
                  <div class="dash-body">
                    <app-chart-donut [config]="item.value.chart.chart"/>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-8 lg:flex-1">
                <div class="dash-card">
                  <div class="dash-header">
                    <div>
                      <h2 class="dash-title">{{ item.value.chart.title }}</h2>
                    </div>
                  </div>
                  <div class="dash-body">
                    <app-dashboard-table [config]="item.value.table"/>
                  </div>
                  <div class="dash-footer">
                    <button pButton type="button" [label]="translations.mostrarDetalle"
                            class="p-button-outlined"
                            (click)="verDetalle(item.value.funcionarioId)"></button>
                  </div>
                </div>
              </div>
            </div>
          }
        }
      }
    </div>
  </div>
</main>
